import Checkbox from '../Checkbox';

const DriversCheckboxCell = ({ data, onToggle }) => (
  <Checkbox checked={data.isChecked} onChange={() => onToggle(data.id)} />
);

export default DriversCheckboxCell;
